import React from 'react';
import type { NodeInstance } from '@glueapp/graph-types';
import type { AgentInstance } from './agentTypes';

interface Props {
    agent: AgentInstance;
    nodeInstances: NodeInstance[];
}

/**
 * Renders a semi-transparent rounded-rect glow around the node the agent
 * is currently working on.
 */
export const AgentSpotlight: React.FC<Props> = ({ agent, nodeInstances }) => {
    if (agent.activeNodeId === null) return null;

    const targetNode = nodeInstances.find(node => node.id === agent.activeNodeId);
    if (!targetNode) return null;

    const padding = 12;
    const nodeX = targetNode.position.x - padding;
    const nodeY = targetNode.position.y - padding;
    const nodeWidth = (targetNode.width || 200) + padding * 2;
    const nodeHeight = (targetNode.height || 100) + padding * 2;
    const cornerRadius = 12;

    return (
        <rect
            x={nodeX}
            y={nodeY}
            width={nodeWidth}
            height={nodeHeight}
            rx={cornerRadius}
            ry={cornerRadius}
            fill={agent.color.light}
            fillOpacity={0.12}
            stroke={agent.color.light}
            strokeOpacity={0.3}
            strokeWidth={2}
        >
            <animate attributeName="fill-opacity" values="0.12;0.06;0.12" dur="2s" repeatCount="indefinite" />
        </rect>
    );
};
